// extracted by mini-css-extract-plugin
module.exports = {"ServiceDetails":"ServiceDetails_ServiceDetails__3FD9U"};